import { Tool } from '../../types';

export const analyticsTools: Tool[] = [
  {
    id: 'google-analytics',
    name: 'Google Analytics',
    category: 'Analytics',
    description: 'Web analytics service for tracking website traffic and user behavior',
    pricing: ['free', 'high'],
    features: ['integrations', 'mobile', 'scalability'],
    bestFor: ['startup', 'small-business', 'freelancer'],
    compatibleWith: ['e-commerce', 'content-creator', 'saas'],
    goals: ['improve-marketing', 'increase-sales'],
    industries: ['technology', 'retail', 'marketing'],
    website: 'https://analytics.google.com',
    imageUrl: 'https://logo.clearbit.com/google.com',
    idealStages: ['launching', 'growing', 'scaling'],
    technicalLevel: ['intermediate', 'advanced'],
    minTeamSize: 'solo'
  },
  {
    id: 'mixpanel',
    name: 'Mixpanel',
    category: 'Analytics',
    description: 'Product analytics for understanding user behavior',
    pricing: ['free', 'medium', 'high'],
    features: ['automation', 'integrations', 'mobile'],
    bestFor: ['startup', 'small-business'],
    compatibleWith: ['saas', 'mobile-app'],
    goals: ['improve-marketing', 'increase-sales'],
    industries: ['technology', 'marketing'],
    website: 'https://mixpanel.com',
    imageUrl: 'https://logo.clearbit.com/mixpanel.com',
    idealStages: ['growing', 'scaling'],
    technicalLevel: ['intermediate', 'advanced'],
    minTeamSize: 'small'
  },
  {
    id: 'amplitude',
    name: 'Amplitude',
    category: 'Analytics',
    description: 'Product analytics platform for digital optimization',
    pricing: ['free', 'medium', 'high'],
    features: ['analytics', 'integrations', 'mobile'],
    bestFor: ['startup', 'small-business'],
    compatibleWith: ['saas', 'mobile-app'],
    goals: ['improve-marketing', 'increase-sales'],
    industries: ['technology', 'marketing'],
    website: 'https://amplitude.com',
    imageUrl: 'https://logo.clearbit.com/amplitude.com',
    idealStages: ['growing', 'scaling'],
    technicalLevel: ['beginner', 'intermediate'],
    minTeamSize: 'small'
  },
  {
    id: 'hotjar',
    name: 'Hotjar',
    category: 'Analytics',
    description: 'Website heatmaps and behavior analytics platform',
    pricing: ['free', 'medium'],
    features: ['analytics', 'ease-of-use', 'integrations'],
    bestFor: ['startup', 'small-business'],
    compatibleWith: ['e-commerce', 'saas'],
    goals: ['improve-marketing', 'enhance-customer-service'],
    industries: ['technology', 'retail', 'marketing'],
    website: 'https://www.hotjar.com',
    imageUrl: 'https://logo.clearbit.com/hotjar.com',
    idealStages: ['launching', 'growing'],
    technicalLevel: ['beginner', 'intermediate'],
    minTeamSize: 'solo'
  }
];